var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-select',{staticClass:"mt-3",staticStyle:{"width":"70px"},attrs:{"items":_vm.items},on:{"change":_vm.changeLangCode},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [_c('gb-flag',{attrs:{"code":item,"size":"small"}})]}},{key:"selection",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [_c('gb-flag',{attrs:{"code":item,"size":"small"}})]}}]),model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }